export const GET_USERINFO = 'GET_USERINFO'; //用户信息
export const GET_PLACES = 'GET_PLACES'; //城市
export const GET_TALENTS = 'GET_TALENTS'; //人才类型
export const GET_TRADE = 'GET_TRADE'; //领域
export const GET_WRCODE = 'GET_WRCODE'; //二维码
export const GET_LOCALS = 'GET_LOCALS'; //机构类型
export const GET_TARGET = 'GET_TARGET'; //需求
export const DEL_USERINFO = 'DEL_USERINFO'; //删除用户信息
export const GET_USER_DIGEST = 'GET_USER_DIGEST'; //用户等级/限量等概况



// WEBPACK FOOTER //
// ./src/store/mutation-types.js